import { withProfiling } from '../self-measurements';
var generateId = withProfiling(function generateId() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 7;
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var result = '';
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
});
export default generateId;